import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {APP} from "../app/consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {NOTIFICATION_APPROVAL_MODULE} from "../../apps/website/modules/notification-approval-module/notification-approval-module.consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";

export class NotificationApprovalDisplayHandler extends ActionHandler {
  localStorageUtils: LocalStorageUtils;
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.notificationApprovalDisplay;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  action(params) {
    this.appStore.state.appNotificationDisplayModel.trigger = params.trigger;

    if(params.isVisible) {
      const countDisplayMessage: Number = (this.localStorageUtils.get(LOCAL_STORAGE_KEYS.countNotificationApprovalMessageDisplays) || 0) + 1;

      if(countDisplayMessage === NOTIFICATION_APPROVAL_MODULE.FIRST_TIME_DISPLAY) {
        this.appStore.state.appNotificationDisplayModel.websiteNotifications = APP.ANALYTICS.NOTIFICATIONS.WEBSITE.neverAsked;
      }

      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.countNotificationApprovalMessageDisplays, countDisplayMessage)
      !this.appStore.state.appNotificationDisplayModel.shouldRenderNotificationApproval && this.sendDisplayEvent(params.trigger, countDisplayMessage);
    }

    this.appStore.state.appNotificationDisplayModel.shouldRenderNotificationApproval = params.isVisible;
  }

  sendDisplayEvent(trigger: String, countDisplayMessage: String) {
    this.controller.action(ACTION_TYPES.notificationsPermissionDisplay, {
      type: APP.ANALYTICS.NOTIFICATIONS.TYPES.website,
      trigger: trigger,
      numShown: countDisplayMessage,
    });
  }
}
